module.exports = __webpack_public_path__ + "static/img/2013@2x.43e4876.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2013@2x.png
// module id = sLzE
// module chunks = 1